import React from 'react';

const Founding = () => {
  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>Our Founding</h1>
        <div style={styles.divider} />
      </div>

      <div style={styles.content}>
        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>The Vision</h2>
          <p style={styles.paragraph}>
            Flying Jib Capital was founded on a straightforward but powerful idea — that
            a disciplined, yield-focused investment strategy executed through a proper
            corporate structure could generate sustainable, compounding returns over time.
          </p>
          <p style={styles.paragraph}>
            The name Flying Jib is a nautical reference to the outermost sail on a vessel —
            the sail that reaches furthest, catches the most wind, and drives the ship forward.
            It reflects our ambition to reach further for yield while maintaining the discipline
            and structure that keeps the vessel on course.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>Why a C-Corporation</h2>
          <p style={styles.paragraph}>
            The decision to structure Flying Jib Capital as a C-corporation was intentional
            from day one. A C-corp provides the institutional credibility necessary to establish
            meaningful banking relationships, the governance framework to operate transparently,
            and the scalability to grow our balance sheet over time.
          </p>
          <p style={styles.paragraph}>
            Unlike pass-through structures, a C-corp allows us to retain earnings, reinvest
            capital, and present a balance sheet that institutional lenders can work with —
            which is central to our leveraged acquisition strategy.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>The Road Ahead</h2>
          <p style={styles.paragraph}>
            We are in the early stages of building Flying Jib Capital into a disciplined,
            yield-focused holding company. Our near-term focus is on establishing our initial
            portfolio of yield-producing ETFs, building our banking relationships, and
            demonstrating the consistency of our strategy through transparent financial reporting.
          </p>
          <p style={styles.paragraph}>
            Every decision we make is oriented toward long-term sustainability — growing
            our asset base methodically, managing leverage responsibly, and maintaining
            the trust of our partners and stakeholders.
          </p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '90vh',
    backgroundColor: '#f4f6f9',
    padding: '60px 40px',
  },
  header: {
    maxWidth: '800px',
    margin: '0 auto 48px auto',
    textAlign: 'center',
  },
  title: {
    fontSize: '42px',
    fontWeight: '700',
    color: '#0a1628',
    fontFamily: 'Georgia, serif',
    letterSpacing: '1px',
    marginBottom: '16px',
  },
  divider: {
    width: '60px',
    height: '3px',
    backgroundColor: '#0a1628',
    margin: '0 auto',
  },
  content: {
    maxWidth: '800px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '48px',
  },
  section: {
    backgroundColor: '#ffffff',
    padding: '40px',
    borderLeft: '3px solid #0a1628',
  },
  sectionTitle: {
    fontSize: '22px',
    fontWeight: '700',
    color: '#0a1628',
    fontFamily: 'Georgia, serif',
    marginBottom: '16px',
    letterSpacing: '0.5px',
  },
  paragraph: {
    fontSize: '16px',
    color: '#4a6080',
    fontFamily: 'Georgia, serif',
    lineHeight: '1.9',
    marginBottom: '16px',
  },
};

export default Founding;